import React, { createContext, useState, useContext } from "react";
import "./UIContext.css";

const UIContext = createContext(null);

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error("useUI must be used within a UIProvider");
  }
  return context;
};

export const UIProvider = ({ children }) => {
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });
  const [confirm, setConfirm] = useState({ show: false, message: "", onConfirm: null });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    // Auto hide after 3 seconds
    const timer = setTimeout(() => {
      setToast((prev) => (prev.message === message ? { ...prev, show: false } : prev));
    }, 3000);
    return () => clearTimeout(timer);
  };

  const showConfirm = (message, onConfirm) => {
    setConfirm({ show: true, message, onConfirm });
  };

  const handleConfirm = () => {
    if (confirm.onConfirm) {
      confirm.onConfirm();
    }
    setConfirm({ show: false, message: "", onConfirm: null });
  };

  const handleCancel = () => {
    setConfirm({ show: false, message: "", onConfirm: null });
  };

  return (
    <UIContext.Provider value={{ showToast, showConfirm }}>
      {children}
      
      {/* Dynamic Toast Notification Alert */}
      {toast.show && (
        <div className={`custom-toast ${toast.type}`}>
          <div className="toast-content">
            <span className="toast-icon">
              {toast.type === "success" ? "✔" : toast.type === "error" ? "❌" : "ℹ"}
            </span>
            <span className="toast-message">{toast.message}</span>
          </div>
          <button className="toast-close" onClick={() => setToast({ ...toast, show: false })}>×</button>
        </div>
      )}

      {/* Custom Confirmation Modal */}
      {confirm.show && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h3>Confirm Action</h3>
            </div>
            <div className="custom-modal-body">
              <p>{confirm.message}</p>
            </div>
            <div className="custom-modal-footer">
              <button className="btn-confirm" onClick={handleConfirm}>Yes, Delete</button>
              <button className="btn-cancel" onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </UIContext.Provider>
  );
};
